import i18n from "i18next";
import {
    initReactI18next
} from "react-i18next";

import en from "./lang/en/translation.json";
import ru from "./lang/ru/translation.json";
import kg from "./lang/kg/translation.json";

const resources = {
    en: { translation: en },
    ru: { translation: ru },
    kg: { translation: kg }
  };


i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "ru", // Устанавливаем язык по умолчанию
        fallbackLng: "ru",
        interpolation: {
            escapeValue: false // React уже экранирует данные
        }
    });

export default i18n;